// Build the full set of species_counts request URLs for a location.
// Shared with offlineSync.js so the synced cache keys match the app's requests.
export const buildiNatUrls = (bbox, firstRetrieval = false, project_id) => {
    const { nelng, nelat, swlng, swlat } = bbox

    // give project_id precedence over bounding box
    let baseurl = `https://api.inaturalist.org/v1/observations/species_counts?nelat=${nelat}&nelng=${nelng}&swlat=${swlat}&swlng=${swlng}&quality_grade=research`
    if (project_id) baseurl = "https://api.inaturalist.org/v1/observations/species_counts?project_id=67346&order=desc&order_by=created_at&quality_grade=research"

    // api requests
    let introduced = [true, false]
    let months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    let urls = []
    let querystring = ''
    if (firstRetrieval) {
        urls.push({
            url: baseurl + '&page=1&per_page=100',
            month: 0,
            introduced: false
        })
    } else {
        for (let i of introduced) {
            for (let m of months) {
                if (m === 0) {
                    querystring = `&introduced=${i}`
                } else {
                    querystring = `&introduced=${i}&month=${m}`
                }
                urls.push({
                    url: baseurl + querystring,
                    month: m,
                    introduced: i
                })
            }
        }
    }
    return urls
}

const getiNatData = (setData, bbox, firstRetrieval=false, project_id) => {

    const urls = buildiNatUrls(bbox, firstRetrieval, project_id)

    console.log("set up iNat API promise")
    Promise.all(
        urls.map(o =>
            fetch(o.url, {mode:'cors'})
                .then(res => res.json())
                .then(data => {
                    return (
                        data.results.map(
                            x => ({
                                ...x,
                                introduced: o.introduced,
                                month: o.month
                            })
                        )
                    )
                })
                .catch(e => { console.log(e); return [] })
        )
    ).then(data => {
        const out = data.reduce((o,x)=>([...o, ...x]),[])
        setData(out);
        console.log("returning inat promise")
    })
}

export default getiNatData
